import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-drill",
  "use": "icon-si-glyph-drill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-drill\" id=\"icon-si-glyph-drill\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>692</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12.999,4 C12.999,3.447 12.552,3 11.999,3 L10.999,3 C10.999,2.447 10.552,2 9.999,2 L8.999,2 C8.999,1.447 8.553,1 8.001,1 L5.009,1 C1.019,1 0.021,3.447 0.021,4 L0.021,7 C0.021,8.983 1.438,9 2,9 L2,9 L0,14 C0,14.553 0.447,15 1,15 L5,15 C5.553,15 6,14.553 6,14 C6,14 2,14 6,9 L6.007,9 C6.559,9 9,9 9,7 L10,7 C10.553,7 11,6.553 11,6 L12,6 C12.553,6 13,5.553 13,5 L16,5 L16,4 L12.999,4 L12.999,4 Z M2.999,4 L3.999,4 L3.999,7 L2.999,7 L2.999,4 L2.999,4 Z M0.999,4 L1.999,4 L1.999,7 L0.999,7 L0.999,4 L0.999,4 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-drill.svg
// module id = An4+
// module chunks = 62